import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './transfer_review_box.less'
import { formatMoney } from 'client/griffin'
import Separator from 'components/common/separator'
import { toCFPBStringId } from 'client/lib/cfpb'

const i18n = getI18n('components/edit_glimpse/transfer_review')

class TransferReviewBox extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number,
    currency: PropTypes.string.isRequired,
    showAmount: PropTypes.bool,
    showFrom: PropTypes.bool,
  }

  static defaultProps = { showAmount: true }

  render() {
    return (
      <div>
        {this.props.showAmount && (
          <div>
            <Separator type="dotted" />
            <div styleName="detail-name">{i18n('transfer_review.amount')}</div>
            <div styleName="detail-value">
              {formatMoney(this.props.currency, this.props.amount)}
            </div>
          </div>
        )}
        <Separator type="dotted" />
        <div styleName="detail-name">{i18n('transfer_review.to')}</div>
        <div styleName="detail-value">
          {i18n(toCFPBStringId('transfer_review.balance'))}
        </div>
        <Separator type="dotted" />
        <div styleName="detail-name">{i18n('transfer_review.from')}</div>
        <div styleName="detail-value">{this.props.title}</div>
        <Separator type="dotted" />
      </div>
    )
  }
}

export default cssModules(TransferReviewBox, styles)
